import { usePaginationContext } from 'utils/contexts/pagination';
import { PaginationUpdateEvent } from 'ui/paginationFooter';

export const useHandlePaginationUpdate = () => {
  const { setCurrentPage, setPageSize } = usePaginationContext();

  return ({ page, pageSize }: PaginationUpdateEvent) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };
};
